// Emergent-managed Google sign-in (per emergentintegrations playbook).
// We DON'T pass a `redirect=` query param here — the Emergent auth proxy
// reads the Origin / Referer header and bounces back to the SAME origin's
// `/profile?session_id=...` (which we override below to /auth/callback).
//
// Implementation note: Emergent OAuth returns the session_id in a URL
// FRAGMENT (`#session_id=...`), not a query string. App.js hoists that
// fragment to `?session_id=...` so React Router can render the callback.
const EMERGENT_AUTH_URL = "https://auth.emergentagent.com/";

export function startGoogleSignIn() {
  if (typeof window === "undefined") return;
  const redirect = `${window.location.origin}/auth/callback`;
  // Append the redirect as a hash anchor — Emergent OAuth then mirrors it.
  window.location.href = `${EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirect)}`;
}
